'use client';

import { useState } from 'react';
import { useAccountUpdateAlertSubscription } from '@frameio/graphql-client/generated';
import { useActiveAccountId } from '@frameio/shared/contexts';
import { AlertBanner } from '@frameio/vapor';
import { BannerWrapper } from './BannerWrapper';
import TEXT from './generated/TEXT/AccountUpdateAlertBanner';

TEXT.DEFINE({
  /** Banner title shown when an account update requires a page reload */
  title: 'Page Refresh Required',
  /** Banner details shown when an account update requires a page reload */
  details: 'Refresh to get the latest updates and avoid unexpected issues.',
  /** CTA button label to reload the page */
  ctaText: 'Refresh Now',
});

export function AccountUpdateAlertBanner() {
  const accountId = useActiveAccountId();
  const [showBanner, setShowBanner] = useState(false);

  useAccountUpdateAlertSubscription({
    variables: { scope: { refreshRequired: { accountId } } },
    skip: !accountId,
    onData: () => {
      setShowBanner(true);
    },
  });

  if (!showBanner) {
    return null;
  }

  return (
    <BannerWrapper>
      <AlertBanner
        ctaText={TEXT.ctaText}
        details={TEXT.details}
        onCtaClick={() => window.location.reload()}
        title={TEXT.title}
        variant="notice"
      />
    </BannerWrapper>
  );
}
